export default __webpack_public_path__ + "static/media/678.378d28e1.png";